export const PERSISTED_TABS_ID_PREFIX = 'HEDGE_POSITION_STATUS' as const;
export const BLOTTER_ID_ALL_STATUS = 'BLOTTER_ID_ALL_STATUS' as const;
export const BLOTTER_ID_ERROR_STATUS = 'BLOTTER_ID_ERROR_STATUS' as const;
export const BLOTTER_ID_HEDGING_STATUS = 'BLOTTER_ID_HEDGING_STATUS' as const;
export const BLOTTER_ID_WAITING_STATUS = 'BLOTTER_ID_WAITING_STATUS' as const;
